import React, { ReactFragment } from "react"
import styles from "./mouthbackground.module.scss"
import 'css-doodle';

interface Props {
  children: ReactFragment
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'css-doodle': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>
    }
  }
}

const MouthBackground = () => {
  return (
    <div className={styles.mouthBackgroundRoot}>
      <css-doodle>{`
        :doodle {
          @grid: 10 x 10;
          @size: 100vmax;
          grid-gap: 0;
        }
        @random(.2) {
          background-image: url(${process.env.PUBLIC_URL + "/logo256.png"});
          background-size: contain;
          background-repeat: no-repeat;
          transform: scale(@rand(.1,.9)) rotate(@rand(0,180)deg) translate3d(@r(-20px, 20px), @r(20px, 20px), 0);
          opacity: @r(0.3,1);
        }
      `}</css-doodle>
    </div>
  )
};

export default MouthBackground
